import React from "react";
import ArrowIcon from "./img/arrowLeft.svg";
import FilerIcon from "./img/filter.svg";
import CreateIcon from "./img/create.svg";
import ArrowIconGrey from "./img/arrowLeftGrey.svg";
import InviteIcon from "./img/inviteUsers.svg";
import "./ButtonComponent.css";
import LoadingSpinner from "../loading/LoadingSpinner";

export const TextButton = (props) => {
  const { label, onClickFunction, disabled, className, icon } = props;
  return (
    <button
      type="button"
      className={`text-button ${className}`}
      onClick={onClickFunction}
      disabled={disabled}
      style={{
        display: "flex",
        alignItems: "center",
        gap: icon ? "0.5rem" : "0",
      }}
    >
      {icon && (
        <img
          loading="lazy"
          src={icon}
          alt="button icon"
          style={{
            width: "1rem",
            height: "1rem",
          }}
        />
      )}
      {label}
    </button>
  );
};

export const PrimaryButton = (props) => {
  const {
    label,
    width,
    onClickFunction,
    disable,
    imageIcon,
    loading,
    buttonType = "button",
  } = props;

  return (
    <button
      type={buttonType}
      className={`primary-button ${disable || loading ? "disabled" : ""}`}
      style={{ width }}
      onClick={(e) => {
        if (!loading && onClickFunction) onClickFunction(e);
      }}
      disabled={disable || loading}
    >
      {imageIcon && (
        <img
          loading="lazy"
          src={imageIcon}
          alt="Button icon"
          className="button-icon"
        />
      )}
      {loading ? <LoadingSpinner size="small" color="white" /> : label}
    </button>
  );
};

export const SecondaryButton = (props) => {
  const { label, width, onClickFunction, imageIcon, fontSize, disable } = props;
  return (
    <button
      type="button"
      className="secondary-button"
      disabled={disable}
      style={{
        border: "1px solid #D0D5DD",
        width: width,
        fontSize: fontSize,
        color: disable ? "#D0D5DD" : "#344054",
        cursor: disable ? "not-allowed" : "pointer",
        background: "#fff",
      }}
      onClick={(e) => {
        if (!disable && onClickFunction) {
          onClickFunction(e);
        }
      }}
    >
      {imageIcon && <img loading="lazy" src={imageIcon} alt="Secondary icon" />}
      {label}
    </button>
  );
};

export const FilterButton = ({ onClick, fontSize, disabled }) => {
  return (
    <button
      type="button"
      className={`filter-button ${disabled ? "filter-button-disabled" : ""}`}
      style={{
        fontSize: fontSize,
      }}
      onClick={(e) => !disabled && onClick(e)}
    >
      <img loading="lazy" src={FilerIcon} alt="filterIcon" />
      Clear Filter
    </button>
  );
};

export const BackButton = (props) => {
  const { label, btnClickBack, color, backgroundColor, fontSize } = props;
  return (
    <button
      type="button"
      className="back-button-container"
      style={{
        background: backgroundColor,
        padding: "0rem",
        fontSize: fontSize,
        color: color,
      }}
      onClick={(e) => btnClickBack(e)}
    >
      <img loading="lazy" src={ArrowIcon} alt="arrowIcon" />
      {label}
    </button>
  );
};

export const LoginBackButton = (props) => {
  const { label, btnClickBack, color, backgroundColor, fontSize } = props;
  return (
    <button
      type="button"
      className="back-button-container"
      style={{
        background: backgroundColor,
        padding: "0rem",
        fontSize: fontSize,
        color: color,
      }}
      onClick={(e) => btnClickBack(e)}
    >
      <img loading="lazy" src={ArrowIconGrey} alt="arrowIcon" />
      {label}
    </button>
  );
};

export const PaginationButton = ({ onClick, disabled, direction }) => {
  const isPrevious = direction === "previous";
  return (
    <button
      className={`pagination-button ${direction}`}
      onClick={onClick}
      disabled={disabled}
    >
      <img
        loading="lazy"
        src={ArrowIconGrey}
        alt={isPrevious ? "Previous page" : "Next page"}
        className={`pagination-icon ${isPrevious ? "previous" : "next"}`}
      />
      <span className="pagination-label">
        {isPrevious ? "Previous" : "Next"}
      </span>
    </button>
  );
};

export const CreateButton = (props) => {
  const { width, onClickFunction, label } = props;

  return (
    <button
      type="button"
      className="create-button"
      style={{ border: "1px solid #365A6D ", width }}
      onClick={(e) => onClickFunction(e)}
    >
      <img loading="lazy" src={CreateIcon} alt="createIcon" />
      {label}
    </button>
  );
};

export const InviteButton = (props) => {
  const { width, onClickFunction } = props;

  return (
    <button
      type="button"
      className="create-button"
      style={{ border: "1px solid #365A6D ", width }}
      onClick={(e) => onClickFunction(e)}
    >
      <img loading="lazy" src={InviteIcon} alt="createIcon" />
      Invite Users
    </button>
  );
};

export const DeleteButton = (props) => {
  const {
    label,
    onClickFunction,
    buttonHeight,
    buttonWidth,
    disable,
    fontSize,
    loading,
  } = props;

  return (
    <button
      type="button"
      className={`button-delete ${disable || loading ? "disabled" : ""}`}
      style={{
        height: buttonHeight,
        width: buttonWidth,
        fontSize: fontSize,
        fontFamily: "Inter",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      disabled={disable || loading}
      onClick={(e) => !loading && onClickFunction(e)}
    >
      {loading ? <LoadingSpinner size="small" color="white" /> : label}
    </button>
  );
};
